import React from "react";

import { bem } from "@react-md/utils";
import { Form } from "antd";
import { FormItemProps as AntFormItemProps } from "antd/es/form/FormItem";
import cn from "classnames";

const block = bem("mmc-form-item");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface FormItemProps<Values = any> extends AntFormItemProps<Values> {
  showLabel?: boolean;
}

const FormItem = ({ children, className, showLabel = true, ...props }: FormItemProps) => {
  return (
    <Form.Item className={cn(block({ ["label-hidden"]: !showLabel }), className)} {...props}>
      {children}
    </Form.Item>
  );
};

export default FormItem;
